import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Colors } from '../../../../../src/constants/style-constants';
import componentBase from '../../../../../src/lib/component-base';
import BannerAd from '../../../../../shared/components/BannerAd/BannerAd';
import * as ads from '../../../ads';
import { openTab } from '../../../../../src/utils/openTab';

const flightGlobalLink = 'https://www.flightglobal.com/';
const fsLegalLink = 'https://www.flightstats.com/company/legal/privacy-policy/';
const fsTermsOfUseLink = 'https://www.flightstats.com/company/legal/terms-of-use/';
const relxLink = 'https://www.relx.com';

@componentBase('FooterComponent')
export default class FooterComponent extends React.Component {
  static propTypes = {
    componentName: PropTypes.string,
    isAccountPage: PropTypes.bool,
    location: PropTypes.object,
    release: PropTypes.string,
    user: PropTypes.object,
    isDesktop: PropTypes.bool,
    parsedComponentName: PropTypes.string,
  };

  constructor(props) {
    super(props);
    const shouldNotDisplayAds = !!props.user && props.user.subscriptionActive;
    this.state = {
      shouldNotDisplayAds,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user && !nextProps.user) { // logging out
      this.changeShouldNotDisplayAds(false);
    } else if (!this.props.user && nextProps.user && nextProps.user.subscriptionActive) { // logging in
      this.changeShouldNotDisplayAds(true); // user has active sub no ads
    } else if (!this.props.user && nextProps.user && !nextProps.user.subscriptionActive) { // logging in
      this.changeShouldNotDisplayAds(false); // user does not have a subscription
    } else if (this.props.user && !this.props.user.subscriptionActive && nextProps.user && nextProps.user.subscriptionActive) {
      // user is inactive but has become active
      this.changeShouldNotDisplayAds(true);
    } else if (this.props.user && this.props.user.subscriptionActive && nextProps.user && !nextProps.user.subscriptionActive) {
      // user is active but has become inactive
      this.changeShouldNotDisplayAds(false);
    } else if (this.props.user && nextProps.user && (this.props.user.subscriptionActive === nextProps.user.subscriptionActive)) {
      // do nothing is subscription status is unchanged
    }
  }

  changeShouldNotDisplayAds = (newState) => {
    if (this.state.shouldNotDisplayAds !== newState) {
      this.setState({ shouldNotDisplayAds: newState });
    }
  }

  footerStyle(subscriptionActive, isMobileMap) {
    const style = {
      background: Colors.blue1,
    };
    if (!this.props.isAccountPage && (subscriptionActive || isMobileMap)) delete style.background;
    return style;
  }

  render() {
    const { location } = this.props;
    const copyrightStyle = {
      color: Colors.gray3,
    };

    const year = moment().format('YYYY');

    let ad;

    const subscriptionActive = this.state.shouldNotDisplayAds &&
                               this.context &&
                               this.context.currentUser &&
                               this.context.currentUser.subscriptionActive;

    const isMobileMap = location.pathname.includes('/map');
    const footerAds = ads[this.props.parsedComponentName];
    if (!this.state.shouldNotDisplayAds && !isMobileMap && footerAds) {
      const adUnits = {
        mobileAd: footerAds.footerMobile,
        desktopAd: footerAds.footer,
      };

      ad = (
        <BannerAd
          {...adUnits}
          subscriptionActive={subscriptionActive}
          style={{
            margin: '0',
          }}
          isDesktop={this.props.isDesktop}
        />
      );
    }


    const logo = (
      <div className='fs-logo-address'>
        <div className='fs-contact-info'>
          <p>522 SW 5th Ave.</p>
          <p>Portland, OR 97204</p>
          <p className='fs-footer-copyright' style={copyrightStyle}>Version {this.props.release}</p>
        </div>
        <a href={flightGlobalLink} className='fs-footer-logo-link-fg' onClick={e => openTab(flightGlobalLink, e)}>
          <img className='part-of-FlightGlobal' src={this.context.images.partOfFlightGlobal} alt='Part of FlightGlobal' />
        </a>
      </div>
    );

    const terms = (
      <div className='fs-company-legal'>
        <a href={fsLegalLink} onClick={e => openTab(fsLegalLink, e)}>
          <p>Privacy Policy</p>
        </a>
        <a href={fsTermsOfUseLink} onClick={e => openTab(fsTermsOfUseLink, e)}>
          <p>Terms of Use</p>
        </a>
        <p className='fs-footer-copyright' style={copyrightStyle}>© FlightStats, Inc. {year}</p>
      </div>
    );

    return (
      <footer className={`footer-component ${this.props.componentName ? this.props.componentName : ''}`} style={this.footerStyle(subscriptionActive, isMobileMap)}>
        <div className={subscriptionActive ? 'footer-top subscription-active' : 'footer-top'}>
          { ad }
        </div>
        <div className={subscriptionActive ? 'footer-bottom subscription-active' : 'footer-bottom'}>
          <div className='footer-left'>
            { terms }
            <a className='relx-group' href={relxLink} onClick={e => openTab(relxLink, e)}>
              <img src={this.context.images.relexGroup} alt='RELX Group' />
            </a>
          </div>
          <div className='footer-right'>
            { logo }
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/App/components/children/Footer/FooterComponent.js